<div class="pipeline-workflow-sidebar" [class.sidebar-collapsed]="sidebarCollapsed" [ngStyle]="themeStyles">
  <div class="nodes-header" *ngIf="readFlag(ui?.nodesHeader?.visible, true)">
    <div class="nodes-title-group">
      <h2 class="nodes-title">{{ readText(ui?.nodesHeader?.title, 'Configured nodes') }}</h2>
      <div class="nodes-meta">{{ readText(ui?.nodesHeader?.meta, (renderedNodes.length + ' nodes')) }}</div>
    </div>
    <!-- Show add button in header only for non-generic (workflow) mode -->
    <button class="btn-add-node" *ngIf="!isGenericMode && readFlag(ui?.nodesHeader?.showAddButton, true)" (click)="triggerAddAction()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      {{ readText(ui?.nodesHeader?.addButtonLabel, 'Add') }}
    </button>
  </div>

  <div class="flow-sidebar">
    <div class="flow-terminal flow-start" *ngIf="readFlag(ui?.startTerminal?.visible, true)">
      <div class="ft-dot"></div>
      <div class="ft-text">
        <span class="ft-label">{{ readText(ui?.startTerminal?.label, 'Record submitted') }}</span>
        <span class="ft-entity">{{ readText(ui?.startTerminal?.entity, config?.name || '') }}</span>
      </div>
    </div>

    <ng-container *ngIf="!renderedNodes.length && readFlag(ui?.emptyState?.visible, true)">
      <div class="flow-empty-area">
        <div class="fic-line long"></div>
        <div class="flow-add-first" (click)="triggerAddAction()">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          {{ readText(ui?.emptyState?.label, 'Add your first node') }}
        </div>
        <div class="fic-line long"></div>
      </div>
    </ng-container>

    <div class="flow-drop-zone" cdkDropList [cdkDropListDisabled]="!enableDrag" [cdkDropListData]="renderedNodes" (cdkDropListDropped)="dropNode($event)">
      <div
        class="flow-node-item"
        *ngFor="let node of renderedNodes; let i = index"
        cdkDrag
        [cdkDragDisabled]="!enableDrag"
        [cdkDragData]="node"
        [class.active]="node.id === activeNodeId"
        (mouseenter)="enableHoverSelection && selectNode(node.id)">
        <div *cdkDragPlaceholder class="flow-placeholder"></div>
        <div *cdkDragPreview class="flow-preview">{{ node.label }}</div>

        <app-pipeline-flow-node [data]="buildFlowNodeData(node, i)"></app-pipeline-flow-node>
      </div>
    </div>

    <!-- Bottom add button for catalog/generic mode -->
    <button
      type="button"
      class="btn-add-catalog-bottom"
      *ngIf="isGenericMode && readFlag(ui?.nodesHeader?.showAddButton, true)"
      (click)="triggerAddAction()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      {{ readText(ui?.nodesHeader?.addButtonLabel, 'Add New Catalog') }}
    </button>

    <ng-container *ngIf="renderedNodes.length && readFlag(ui?.bottomInsert?.visible, true)">
      <div class="flow-out-connector">
        <div class="fic-line"></div>
        <button class="fic-insert" (click)="triggerAddAction()" [title]="readText(ui?.bottomInsert?.tooltip, 'Add node at end')">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
            <path d="M4 1v6M1 4h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="fic-line"></div>
        <div class="fic-arrow" *ngIf="readFlag(ui?.bottomInsert?.showArrow, true)">
          <svg width="9" height="6" viewBox="0 0 9 6" fill="none">
            <path d="M4.5 6L0 0h9L4.5 6z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </ng-container>

    <div class="flow-terminal flow-end" *ngIf="readFlag(ui?.endTerminal?.visible, true)">
      <div class="ft-dot"></div>
      <div class="ft-text">
        <span class="ft-label">{{ readText(ui?.endTerminal?.label, 'All gates passed') }}</span>
        <span class="ft-approved">{{ readText(ui?.endTerminal?.entity, 'Approved') }}</span>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showAddModal && !useCustomAddAction" (click)="closeModalOnBackdrop($event)">
    <div class="modal-box" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div class="modal-header">
        <h3 id="modal-title">{{ readText(ui?.addNodeModal?.title, 'Add flow node') }}</h3>
        <button class="modal-close" (click)="showAddModal = false" aria-label="Close">&#x2715;</button>
      </div>
      <div class="modal-body">
        <p class="modal-hint">{{ readText(ui?.addNodeModal?.hint, 'Choose a node type to add to this workflow:') }}</p>
        <div class="node-type-grid">
          <div
            class="node-type-card"
            *ngFor="let nodeType of nodeTypeOptions"
            (click)="addNewNode(nodeType.type)"
            role="button"
            tabindex="0"
            (keydown.enter)="addNewNode(nodeType.type)"
            (keydown.space)="addNewNode(nodeType.type)">
            <div class="node-type-icon" [class.auto]="nodeType.type === 'AUTO_APPROVE'" [class.parallel]="nodeType.type === 'PARALLEL'" [class.hierarchy]="nodeType.type === 'HIERARCHY'">
              <svg *ngIf="nodeType.type === 'AUTO_APPROVE'" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10l4 4 8-8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="nodeType.type === 'PARALLEL'" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 4v12M5 7l5-3 5 3M5 13l5 3 5-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="nodeType.type === 'HIERARCHY'" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="5" r="2" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="5" cy="15" r="2" stroke="currentColor" stroke-width="1.5"/>
                <circle cx="15" cy="15" r="2" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 7v4M8 11l-1.5 2M12 11l1.5 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <div class="node-type-name">{{ nodeType.title }}</div>
            <div class="node-type-desc">{{ nodeType.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
